import { Authentication, BasePostRequest } from './';
import * as t from 'io-ts';

export class AcceptAccountLinkRequest extends BasePostRequest<undefined> {
    constructor(acceptAccountLinkInviteToken: string) {
        super(`account-links/accept/${encodeURIComponent(acceptAccountLinkInviteToken)}/`, {}, null, t.undefined, Authentication.Login);
    }
}
